export default "__VITE_ASSET__CXoTDVSx__"